<template>
	<div>
		<v-app
			v-if="
				!loading ||
				['login', ...allowedPagesOutOfFinancialFileContext].includes($route.name) ||
				$route.name?.includes('statistics')
			"
		>
			<Navigation
				v-if="
					isAuthenticated && (
						(
							!!isFileSelected &&
							!['login', 'splash-window'].includes($route.name)
						) ||
						$route.name?.includes('statistics') ||
						allowedPagesOutOfFinancialFileContext.includes($route.name)
					)
				"
			/>
			<v-main>
				<v-dialog v-model="timeZoneAlertDialog" max-width="550">
					<v-card>
						<v-card-title>
							{{ $t('timezone-alert') }}
						</v-card-title>
						<v-card-text class="pb-2">
							<span>
								{{$t('timezone-alert-description')}}
								<br>
								{{$t('user-timezone')}}: {{ userTimezone }}
								<br>
								{{ $t('current-timezone') }}: {{ currentUserTimezone }}
								<br>
							</span>
							<span v-if="!isAdmin">{{$t('contact-admin')}}</span>
							<v-checkbox v-model="hideTimezoneAlert" :label="$t('hide-at-all')" dense hide-details></v-checkbox>
						</v-card-text>
						<v-card-actions>
							<v-btn color="primary" text @click="timeZoneAlertDialog = false; hideTimezoneAlert ? ls.setTimezoneAlertStatus(false) : null">
								{{$t('buttons.ok')}}
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<router-view>
					<template v-slot:breadcrumbs="{ item }">
						<bee-breadcrumbs :show-only-title="!!item"></bee-breadcrumbs>
						<bee-snackbar ref="snackbar" />
					</template>
				</router-view>
			</v-main>
		</v-app>
		<v-app v-else-if="loading && $route.name != 'login'">
			<v-main>
				<splash-window></splash-window>
				<bee-snackbar ref="snackbar" />
			</v-main>
		</v-app>
	</div>
</template>

<script>
import Navigation from './components/Navigation';
import EventBus from './event-bus';
import { mapGetters, mapState } from 'vuex';
import ls from './settings/localStorageExtension';
import availableLangs from './settings/constants/availableLangs';
import timezones from '@/helpers/timeZones'
export default {
	name: 'App',
	
	components: {
		Navigation
	},

	data() {
		return {
			isFileSelected: ls.getLocalFinancialFileId(),
			allowedPagesOutOfFinancialFileContext: ['quick-financial-file-selector', 'financial-files', 'users', 'currencies', 'global-settings'],
			loading: true,
			timeZoneAlertDialog: false,
			userTimezone: null,
			currentUserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			timezones,
			ls,
			hideTimezoneAlert: false
		};
	},

	watch:{
		'$i18n.locale'(val){
			this.$vuetify.lang.current = val;
			
			this.setAppDirection();
			const userLang = availableLangs.find(c => c.key === this.$i18n.locale)?.id ?? 1;
			this.$store.dispatch('users/changeLanguage', { language: userLang })
			
			if (this.$route.name !== 'login') {
				this.loading = true;
				setTimeout(() => {
					this.loading = false;
				}, 1000)
			}
		},
		'user'(val) {
			if(val.time_zone) {
				this.showTimezoneAlert(val.time_zone)
				this.timeZoneAlertDialog = ls.getTimezoneAlertStatus() === 'true';
			}
		}
	},

	computed: {
		...mapGetters({ isAuthenticated: 'auth/isAuthenticated' }),
		...mapState({
			user: state => state.users.oneUser,
			isAdmin: state => state.auth?.self?.is_admin
		})
	},

	created() {
		window.addEventListener('resize', this.initializeMainDivTop);
		window.addEventListener('visibilitychange', this.initializeMainDivTop);
		window.addEventListener('contextmenu', function (event) {
			if(event.target.closest('a')) {
				ls.setLastUsedFinancialFileId(ls.getLocalFinancialFileId());
			}
		}
		)
	},

	methods:{
		setAppDirection(){
			if (this.$i18n.locale === 'ar'){
				this.$vuetify.rtl = true;
			}
			else {
				this.$vuetify.rtl = false;
			}
		},
		showTimezoneAlert(userTimezone) {
			const userTime = this.timezones().find(v => v.timezone === userTimezone).dateTime.split(', ')[1];
			this.userTimezone = userTimezone;
			const currentUserTime = this.timezones().find(v => v.timezone === this.currentUserTimezone).dateTime.split(', ')[1];
			if(this.currentUserTimezone !== userTimezone && userTime !== currentUserTime){
				if(ls.getTimezoneAlertStatus() !== 'false')
				{
					ls.setTimezoneAlertStatus(true);
				}
			}
		}
	},

	mounted() {
		this.setAppDirection();
		this.initializeMainDivTop();
		// test - converting logic to global

		// const toolBars = document.getElementById("app").querySelectorAll("#tool-bar");
		// toolBars.forEach( toolBar => {
		// 	console.log(toolBar)
		// 	window.observer.observe(toolBar)
		// });

		// const footers = document.getElementById("app").querySelectorAll("#footer");
		// footers.forEach( footer => {
		// 	window.observer.observe(footer)
		// });

		document.querySelectorAll('input').forEach(input => {
			input.addEventListener('input', () => {
				if (input.value.length > 25 && input.value.length < 40) input.style.fontSize = '13px';
				if (input.value.length > 40) input.style.fontSize = '11px';
				if (input.value.length < 25) input.style.fontSize = '16px';
			});
		});
		EventBus.$on('error', e => this.$refs.snackbar.show(e));
		EventBus.$on('notification', e => this.$refs.snackbar.notify(e));
		EventBus.$on('financial-file-id-changed', () => {
			this.isFileSelected = ls.getLocalFinancialFileId();
		});
		EventBus.$on('data-loaded', () => {
			this.loading = false;
		});
		EventBus.$on('assign-dynamic-width', () => {
			document.getElementsByClassName('dynamic-width').forEach(v => {
				var classes = [].slice.apply(v.classList);
				var widthClass = classes.find(c => c.includes('dynamic-width-'));
				v.style.width = widthClass.substring(14, 17);
				v.style.overflowWrap = 'anywhere';
			});
		});
	},

	destroyed() {
		window.removeEventListener('visibilitychange', this.initializeMainDivTop);
		window.removeEventListener('resize', this.initializeMainDivTop);
	},
	
	meta: {
		title: 'Home',
		titleTemplate: '%s | Emerald',
	},
	// meta() {
	// 	const routeName = this.$route.name.replace(/-/g, ' ');
	// 	return {
	// 		title: routeName[0].toUpperCase() + routeName.slice(1),
	// 		titleTemplate: '%s | Emerald',
	// 		meta: [{ property: 'og:image', content: '/assets/mirta-logo.png' }]
	// 	}
	// }
};
</script>
<style lang="scss">
@import './scss/main.scss';

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
	-webkit-box-shadow: 0 0 0 30px #424242 inset !important;
	-webkit-text-fill-color: white !important;
}

.fade-enter-active,
.fade-leave-active {
	transition-property: opacity;
	transition-duration: 0.15s;
}

.fade-enter-active {
	transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.hidden {
	visibility: hidden !important;
}

.visible {
	visibility: visible !important;
}
.pace {
	-webkit-pointer-events: none;
	pointer-events: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	user-select: none;
}

.pace-inactive {
	display: none;
}

.pace .pace-progress {
	background: white;
	position: fixed;
	z-index: 2000;
	top: 0;
	right: 100%;
	width: 100%;
	height: 3px;
}

.pace .pace-progress-inner {
	display: block;
	position: absolute;
	right: 0px;
	width: 100px;
	height: 100%;
	box-shadow: 0 0 10px #50b1dc, 0 0 5px #50b1dc;
	opacity: 1;
	-webkit-transform: rotate(3deg) translate(0px, -4px);
	-moz-transform: rotate(3deg) translate(0px, -4px);
	-ms-transform: rotate(3deg) translate(0px, -4px);
	-o-transform: rotate(3deg) translate(0px, -4px);
	transform: rotate(3deg) translate(0px, -4px);
}

.pace .pace-activity {
	display: block;
	position: fixed;
	z-index: 2000;
	top: 25px;
	left: 50%;
	transform: translateX(-50%);
	width: 14px;
	height: 14px;
	border: solid 2px transparent;
	border-top-color: white;
	border-left-color: white;
	border-radius: 10px;
	-webkit-animation: pace-spinner 400ms linear infinite;
	-moz-animation: pace-spinner 400ms linear infinite;
	-ms-animation: pace-spinner 400ms linear infinite;
	-o-animation: pace-spinner 400ms linear infinite;
	animation: pace-spinner 400ms linear infinite;
}

@-webkit-keyframes pace-spinner {
	0% {
		-webkit-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-webkit-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@-moz-keyframes pace-spinner {
	0% {
		-moz-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-moz-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@-o-keyframes pace-spinner {
	0% {
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@-ms-keyframes pace-spinner {
	0% {
		-ms-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		-ms-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes pace-spinner {
	0% {
		transform: rotate(0deg);
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

/* @media (max-width: 1500px) and (min-width: 1200px) {
  body {
    zoom: 0.9;
  }
} */

*::-webkit-scrollbar {
	width: 8px;
}
*::-webkit-scrollbar-track {
	background: #f2f2f2;
}
*::-webkit-scrollbar-thumb {
	background-color: #ccc;
	border-radius: 12px;
}
.relative {
	position: relative !important;
}
.fixed {
	position: fixed !important;
	top: auto !important;
	z-index: 1 !important;
}
.absolute {
	position: absolute !important;
}

.rounded{
	&-start{
		border-radius: 0 !important;
		[dir="rtl"] & {
			border-top-right-radius: 4px !important;
			border-bottom-right-radius: 4px !important;
		}
		[dir="ltr"] & {
			border-top-left-radius: 4px !important;
			border-bottom-left-radius: 4px !important;
		}
	}
	&-end{
		border-radius: 0 !important;
		[dir="rtl"] & {
			border-top-left-radius: 4px !important;
			border-bottom-left-radius: 4px !important;
		}
		[dir="ltr"] & {
			border-top-right-radius: 4px !important;
			border-bottom-right-radius: 4px !important;
		}
	}
}

.border-round{
	&-start{
		[dir="rtl"] & {
			border-top-right-radius: 8px !important;
			border-bottom-right-radius: 8px !important;
		}
		[dir="ltr"] & {
			border-top-left-radius: 8px !important;
			border-bottom-left-radius: 8px !important;
		}
	}
	&-end{
		[dir="rtl"] & {
			border-top-left-radius: 8px !important;
			border-bottom-left-radius: 8px !important;
		}
		[dir="ltr"] & {
			border-top-right-radius: 8px !important;
			border-bottom-right-radius: 8px !important;
		}
	}
	&-bottom {
		border-bottom-right-radius: 8px !important;
		border-bottom-left-radius: 8px !important;
	}
}

.border {
	&-1 { border: 1px solid #ccc; }
	&-2 { border: 2px solid #ccc; }
	&-3 { border: 3px solid #ccc; }
}

.rounded {
	&-large {
		border-radius: 15px !important;
	}
	&-medium {
		border-radius: 11px !important;
	}
	&-small {
		border-radius: 9px !important;
	}
}

.border-container {
	padding: 8px 10px;
	border-radius: 10px;
	border: 1px solid #eee;
}

.h-100 {
	height: 100%;
}
.w-100 {
	width: 100%;
}

.dialog-divider {
	display: block;
	max-width: 350px;
	width: 80%;
	height: 1px;
	background-color: #ccc;
	[dir='rtl'] & { margin-right: 18px; }
	[dir='ltr'] & { margin-left: 18px; }
}

#app {
	.v-snack__wrapper {
		border-radius: 11px;
	}
	.v-btn:not(.v-btn--fab, .v-btn--icon), .v-list {
		border-radius: 10px;	
	}
	.v-item-group {
		border-radius: 12px;	
	}
	.v-menu__content {
		border-radius: 10px;	
	}
	.v-data-table, .v-data-table__wrapper, .v-data-table-header {
		border-radius: 15px;
	}
	.v-input {
		border-radius: 9px;
	}
	.v-list-item {
		min-height: 35px;
	}

	.apexcharts-toolbar {
		z-index: 0;
	}

	.v-data-table {
		.bee-handy-smart-table__input-cell {
			padding: 0 8px;

			& .v-input.mb-4, .mb-4 {
				margin-bottom: 10px !important;
			}
		}
		.v-input{
			border: none;
		}
		tr:last-child:not(.bee-handy-smart-table__add-row) td{
			border-bottom: 1px solid #e0e0e0;
		}
	}
}
</style>